import React from 'react'
import Layout from '../components/Layout/Layout'
import PrivacyPolicyComponent from '../components/PrivacyPolicyComponent'

const PrivacyPolicy = () => {
  return (
    <>
     <Layout>
        <PrivacyPolicyComponent />
     </Layout>
    </>
  )
}

export default PrivacyPolicy